<div class="dialog-header">
    <h2 mat-dialog-title class="lmc-dialog-title dialog-title-icon">
        <mat-icon color="primary">history</mat-icon>
        Co-applicant history
    </h2>
    <button mat-icon-button mat-dialog-close type="button"
            class="close-button" aria-label="Close" matTooltip="Close">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content>
    <div class="empty-state" *ngIf="isLoading">
        <mat-spinner diameter="32"></mat-spinner>
        <span>Loading history…</span>
    </div>

    <div class="empty-state" *ngIf="loadFailed">
        <mat-icon>error_outline</mat-icon>
        <span>Could not load the co-applicant history</span>
    </div>

    <ng-container *ngIf="!isLoading && !loadFailed">
        <!-- <div class="stats">
            <span class="stat"><strong>{{ removalCount }}</strong> {{ removalCount === 1 ? 'removal' : 'removals' }}</span>
            <span class="stat stat--restored"><strong>{{ restoreCount }}</strong> {{ restoreCount === 1 ? 'restore' : 'restores' }}</span>
        </div> -->

        <div class="feed">
            <ng-container *ngFor="let event of events; let i = index; trackBy: trackEvent">
                <div class="day-header" *ngIf="i === 0 || events[i - 1].dayKey !== event.dayKey">
                    <span class="day-label">{{ formatDay(event.date) }}</span>
                </div>

                <div class="entry">
                    <div class="time" [matTooltip]="formatDateTime(event.date)">{{ formatTime(event.date) }}</div>
                    <div class="rail">
                        <span class="marker" [ngClass]="'marker--' + event.kind">
                            <mat-icon>{{ eventIcons[event.kind] }}</mat-icon>
                        </span>
                    </div>

                    <div class="entry-card">
                        <div class="headline">
                            <span class="name">{{ event.coApplicantName }}</span>
                            <span class="action" [ngClass]="'action--' + event.kind">{{ eventLabels[event.kind] }}</span>
                            <span class="by">by</span>
                            <span class="who">{{ event.doneBy }}</span>
                        </div>
                        <div class="detail" *ngIf="event.reason">
                            <span class="detail-label">Reason</span>
                            <span class="detail-value">{{ event.reason }}</span>
                        </div>
                        <div class="detail detail--error" *ngIf="event.errorMessage">
                            <span class="detail-label">Error</span>
                            <span class="detail-value">{{ event.errorMessage }}</span>
                        </div>
                    </div>
                </div>
            </ng-container>

            <div class="empty-state" *ngIf="!events.length">
                <mat-icon>history</mat-icon>
                <span>No co-applicant changes on this application</span>
            </div>
        </div>
    </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button type="button" mat-dialog-close>Close</button>
</mat-dialog-actions>
